import createVueComponent from '../createVueComponent';

const Users2 = createVueComponent('Users2Icon', [
  ['path', { d: 'M14 19a6 6 0 0 0-12 0', key: 'vej9p1' }],
  ['circle', { cx: '8', cy: '9', r: '4', key: '143rtg' }],
  ['path', { d: 'M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8', key: 'hqbn22' }],
]);

export default Users2;
